import { Component, inject } from '@angular/core';

import { Store } from '@ngrx/store';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { GuestApiModel } from '@era/inroom-sdk';

import {
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { MobileReservationGuestModalConfirmed } from '../../../stores/mobilereservation/mobilereservation.actions';
import { selectCurrentRoom } from '../../../stores/rooms/rooms.selector';

@Component({
  selector: 'era-guest-checkin-modal',
  templateUrl: './guest-checkin-modal.component.html',
  imports: [ReactiveFormsModule, FaIconComponent],
})
export class GuestCheckinModalComponent {
  public readonly activeModal = inject(NgbActiveModal);
  private readonly store = inject(Store);
  private readonly fb = inject(UntypedFormBuilder);

  private readonly room = this.store.selectSignal(selectCurrentRoom);

  public readonly checkinForm: UntypedFormGroup = this.fb.group({
    checkinDate: ['', Validators.required],
    checkoutDate: ['', Validators.required],
    booker: this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      emailAddress: [''],
    }),
    guests: this.fb.array([]),
  });

  get guests(): UntypedFormArray {
    return this.checkinForm.get('guests') as UntypedFormArray;
  }

  get booker(): GuestApiModel {
    return {
      FirstName: this.checkinForm.get(['booker', 'firstName'])?.value,
      LastName: this.checkinForm.get(['booker', 'lastName'])?.value,
      EmailAddress: this.checkinForm.get(['booker', 'emailAddress'])?.value,
    };
  }

  public addGuest() {
    this.guests.push(
      this.fb.group({
        guestFirstName: ['', Validators.required],
        guestLastName: ['', Validators.required],
      })
    );
  }

  public deleteGuest(index: number) {
    this.guests.removeAt(index);
  }

  public onSubmit() {
    if (this.booker.FirstName == null && this.booker.LastName == null) {
      return;
    }

    const room = this.room();
    this.store.dispatch(
      new MobileReservationGuestModalConfirmed({
        mobileReservation: {
          SubReservations: [
            {
              ArrivalDate: this.checkinForm.get('checkinDate')?.value,
              DepartureDate: this.checkinForm.get('checkoutDate')?.value,
              UnitType: '',
              UnitCode: room?.Room,
              NumberOfGuests: this.checkinForm.get('guests')?.value?.length ?? -1,
              Status: 'checked in (via UI)',
              PrimaryGuest: this.booker,
            },
          ],
          HotelCode: room?.HotelCode,
          Booker: this.booker,
        },
      })
    );
    this.checkinForm.reset();
    this.activeModal.close();
  }
}
